import React from 'react';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import { NEW_PLATFORM } from '../../../../constants/Copy';
import { getConfig } from '../../../../apiConfig';

const NewPlatform = () => {
	const { bedrock } = getConfig();

	return (
		<FullPageMessage
			hasSpinner
			button={{
				href: bedrock,
				text: NEW_PLATFORM.BUTTON,
			}}
			text={NEW_PLATFORM.TEXT}
			title={NEW_PLATFORM.TITLE}
			// eslint-disable-next-line react/no-danger
			description={<p dangerouslySetInnerHTML={{ __html: NEW_PLATFORM.DESCRIPTION }} />}
		/>
	);
};

export default NewPlatform;
